var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPartnerCheckmark = function SvgPartnerCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#partner-checkmark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.76 5.5c0-.57.37-1.19.19-1.7s-.86-.82-1.2-1.26c-.34-.44-.42-1.17-.88-1.49C8.41.73 7.68.87 7.13.7 6.58.53 6.13 0 5.5 0c-.63 0-1.09.54-1.62.7-.53.16-1.29 0-1.75.35-.46.35-.54 1-.88 1.49-.34.49-1 .73-1.2 1.26-.2.53.2 1.13.2 1.7 0 .57-.37 1.19-.2 1.7.17.51.86.83 1.2 1.27.34.44.42 1.16.88 1.49.46.33 1.19.17 1.75.34s1 .7 1.62.7c.62 0 1.09-.54 1.63-.71.54-.17 1.28 0 1.74-.34.46-.34.54-1 .88-1.49.34-.49 1-.73 1.2-1.27.2-.54-.19-1.14-.19-1.69z",
    fill: "#85BB65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.34 5.65 1.47 1.33L7.65 4.4",
    stroke: "#fff",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "partner-checkmark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h11v11H0z"
  })))));
};

export default SvgPartnerCheckmark;